import React from 'react';
import { Card, CardContent, CardHeader, CardProps, Typography, Box } from '@mui/material';

interface StyledCardProps extends CardProps {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  headerAction?: React.ReactNode;
  padding?: number | string;
}

const StyledCard: React.FC<StyledCardProps> = ({
  title,
  subtitle,
  children,
  headerAction,
  padding = 3,
  ...props
}) => {
  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        ...props.sx,
      }}
      {...props}
    >
      {(title || subtitle || headerAction) && (
        <CardHeader
          title={
            title ? (
              <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                {title}
              </Typography>
            ) : undefined
          }
          subheader={
            subtitle ? (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            ) : undefined
          }
          action={headerAction}
          sx={{
            pb: title || subtitle ? 1 : 0,
            '& .MuiCardHeader-content': {
              overflow: 'hidden',
            },
            '& .MuiCardHeader-title': {
              fontSize: '1.25rem',
              lineHeight: 1.3,
            },
          }}
        />
      )}
      
      <CardContent
        sx={{
          flexGrow: 1,
          p: padding,
          '&:last-child': {
            pb: padding,
          },
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default StyledCard; 